import {Header} from "../../components/general/Header.tsx";
import {User} from "../../api/accessControl/User.ts";
import {SecondaryButton} from "../../components/general/SecondaryButton.tsx";
import {PrimaryButton} from "../../components/general/PrimaryButton.tsx";
import {BuildingLibraryIcon} from "@heroicons/react/24/outline";

export function BeforeConnectABank({currentUser}: { currentUser: User }) {


    return (
        <div>
            <Header disableX={true}/>
            <div className="bg-white">
                <div className="mx-auto flex flex-col items-center text-center max-w-1xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                    <img src="/quinn-transparent.png" alt="" className={'h-64 mx-auto my-8'}/>
                    <h1 className="font-semibold text-3xl mb-6 ">Welkom {currentUser.firstName}!</h1>
                    <p className="mx-auto mt-2 text-sm leading-6 text-gray-500 mb-8 max-w-96">
                        Leuk je aan boord te hebben! Om PocketCFO te kunnen gebruiken, moet je een bank koppelen. Dit is
                        een veilige verbinding via open banking. Koppel een bank om het product te gebruiken.
                    </p>
                    <PrimaryButton title={'Koppel een bankrekening'} icon={BuildingLibraryIcon} onClick={()=>{
                        window.location.href = '/connect-a-bank'
                    }}/>

                </div>
            </div>
        </div>
    )
}
